import { Typography } from '@mui/material';
import styled from 'styled-components';

const NothingUpcomingText = styled(Typography)`
  && {
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing(6)};
    margin-bottom: ${({ theme }) => theme.spacing(6)};
    user-select: none;
  }
`;

export { NothingUpcomingText };
